import React from 'react'
import { Link } from 'react-router-dom'
import { Cpu, ArrowRight, Clock } from 'lucide-react'
import { ARTICLES } from '../../features/tech-hub/techArticles'

// Section "Công nghệ số dành cho giáo viên" nhúng trên trang chủ ebook.
const TechHubSection: React.FC = () => {
  const items = ARTICLES.slice(0, 3)
  if (!items.length) return null
  return (
    <section className="mx-auto max-w-6xl px-4 py-12">
      <div className="mb-6 flex items-end justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="grid h-11 w-11 place-items-center rounded-2xl bg-blue-600 text-white"><Cpu size={22} /></span>
          <div>
            <p className="text-[11px] font-black uppercase tracking-widest text-blue-600">Kiến thức thiết thực</p>
            <h2 className="text-xl sm:text-2xl font-black text-slate-900">Công nghệ số dành cho giáo viên</h2>
          </div>
        </div>
        <Link to="/cong-nghe-so" className="hidden sm:inline-flex items-center gap-1.5 text-sm font-black text-blue-600 hover:underline no-underline">
          Xem tất cả <ArrowRight size={15} />
        </Link>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((a) => (
          <Link
            key={a.slug}
            to={`/cong-nghe-so/${a.slug}`}
            className="group flex flex-col rounded-3xl border border-slate-100 bg-white p-6 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md no-underline"
          >
            <div className="flex items-center gap-2 text-xs font-black uppercase tracking-wide text-blue-600">
              <span>{a.tag}</span>
              <span className="text-slate-300">·</span>
              <span className="inline-flex items-center gap-1 text-slate-400"><Clock size={12} /> {a.readMin}′</span>
            </div>
            <h3 className="mt-2 text-base font-black leading-snug text-slate-900">{a.emoji} {a.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600 line-clamp-3">{a.excerpt}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-black text-blue-600">
              Đọc bài <ArrowRight size={15} className="transition group-hover:translate-x-0.5" />
            </span>
          </Link>
        ))}
      </div>
      <Link to="/cong-nghe-so" className="mt-5 inline-flex sm:hidden items-center gap-1.5 text-sm font-black text-blue-600 no-underline">
        Xem tất cả <ArrowRight size={15} />
      </Link>
    </section>
  )
}

export default TechHubSection
